export default __webpack_public_path__ + "static/media/17-ITunes.a3c422fc.png";